module.exports = __webpack_public_path__ + "static/img/icon_star_rare@2x.2b18602f.png";